import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI, { provide } from '@vue/composition-api'
import { ApolloClients } from '@vue/apollo-composable'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'

// Axios Mock Adapter
import '@/@fake-db/db'

import { createProvider } from './vue-apollo'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  setup() {
    provide(ApolloClients, {
      default: createProvider().defaultClient,
    })
  },
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#app')
